import { GameManager } from "../../GameManager";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Background } from "../Background";
import { LowerMenu } from "../LowerMenu";
import { PlayerInfoContainer } from "../PlayerInfoContainer";
import { AudioButtonContainer } from "../AudioButtonContainer";
import { GameModeSelectionMenu } from "./GameModeSelectionMenu";
import { DifficultySelectionMenu } from "./DifficultySelectionMenu";
import { Game } from "../../Game";
import { AudioManager } from "../../AudioManager";

export class SplashScene extends Phaser.Scene {

    public static currentInstance: SplashScene;

    private playerAvatar: PlayerInfoContainer;
    private gameModeSelectionMenu: GameModeSelectionMenu;
    private difficultySelectionMenu: DifficultySelectionMenu;

    constructor() {

        super("SplashScene");
        
        SplashScene.currentInstance = this;
    }

    public create(): void {

        GameManager.setCurrentScene(this);   

        const background = new Background(this, 1);
        this.add.existing(background);

        this.playerAvatar = new PlayerInfoContainer(this);
        this.add.existing(this.playerAvatar);

        const audioButton = new AudioButtonContainer(this);
        audioButton.x = GameConstants.GAME_WIDTH - 60;
        audioButton.y = 60 * GameVars.scaleY;
        audioButton.scaleY = GameVars.scaleY;
        this.add.existing(audioButton);

        const scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);
        scaledItemsContainer.scaleY = GameVars.scaleY;

        this.gameModeSelectionMenu = new GameModeSelectionMenu(this);
        this.gameModeSelectionMenu.visible = false;
        scaledItemsContainer.add(this.gameModeSelectionMenu);

        this.time.delayedCall(200, function(): void {
            this.gameModeSelectionMenu.visible = true;
        }, [], this);

        this.difficultySelectionMenu = new DifficultySelectionMenu(this);
        this.difficultySelectionMenu.visible = false;
        scaledItemsContainer.add(this.difficultySelectionMenu);

        const lowerMenu = new LowerMenu(this);
        this.add.existing(lowerMenu);

        if (!this.sys.game.device.os.desktop) {
            this.input.on("pointerup", function(): void {
                Game.currentInstance.launchIntoFullscreen(document.documentElement);
            }, this);
        }

        AudioManager.playSound("soundtrack_menues", true);
    }

    public update(): void {

        this.gameModeSelectionMenu.update();
    }

    public onFullScreen(): void {

        this.playerAvatar.scaleY = GameVars.scaleY;
    }

    public onGameModeSelected(): void {

        AudioManager.playSound("click_btn");

        this.gameModeSelectionMenu.visible = false;

        this.time.delayedCall(150, function(): void {
            this.difficultySelectionMenu.visible = true;
            this.difficultySelectionMenu.onGameModeSelected();
        }, [], this);
    }

    public onBackFromDifficultySelection(): void {

        this.time.delayedCall(150, function(): void {
            this.gameModeSelectionMenu.visible = true;
        }, [], this);

        this.difficultySelectionMenu.visible = false;
    }
}
